<template>
  <div class="layout__padding-clear">
    <div class="layout__position__relative">
      <img
        class="layout__width-100 layout__height-100 layout__padding-clear"
        src="https://rpsassets.blob.core.windows.net/rpsimages/images/banners/instantprint_header.jpg"
      >
      <div class="layout__padding-clear">
        <div class="component__banner-subtitle layout__padding-clear">
          <!--<div class="layout__padding-30px">-->
          <!--<img class="layout__width-250px" src="https://rpsassets.blob.core.windows.net/rpsimages/images/logos/InstantPrintLogoWhite.png">-->
          <!--</div>-->
          <!--<div class="layout__width-50 layout__padding-clear">-->
          <!--Upload your artwork, choose your options and we'll take care of the rest-->
          <!--</div>-->
          <div class="text__align-center">
            <el-button
              class="button__background-red button__base__header-large layout__width-200px layout__margin__top-20"
              @click="onGetStarted"
            >Get Started
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="text__align-center layout__padding-20-0">
      <h2 class="text__colour-teal layout__padding-20-0">3 Simple Steps to Beautiful Print</h2>

      <div class="text__colour-grey layout__padding-5-0 text__size-16">If you've got prepared artwork, we'll help
        you turn it into beautiful printed collateral.
      </div>
      <div class="text__colour-grey text__size-16">Upload your artwork and follow this super simple 3 step
        process:
      </div>
      <div class="layout__padding-clear layout__width-50">
        <div class="layout__height-50px layout__border__bottom-light-teal layout__margin-30-0">
          <div class="component__columns-3">
            <div class="layout__width-100px">
              <img
                class="layout__width-100px layout__position-left"
                src="https://rpsassets.blob.core.windows.net/rpsimages/images/instant_print/preview.png"
              >
              <h4 class="layout__padding-clear text__align-center layout__padding-20-0 text__colour-teal">
                Preview your artwork
              </h4>
            </div>
          </div>
          <div class="component__columns-3">
            <div class="layout__width-100px layout__padding-clear">
              <img
                class="layout__width-100px"
                src="https://rpsassets.blob.core.windows.net/rpsimages/images/instant_print/select.png"
              >
              <h4 class="layout__padding-clear text__align-center layout__padding-20-0 text__colour-teal">
                Select print options
              </h4>
            </div>
          </div>
          <div class="component__columns-3">
            <div class="layout__width-100px layout__position-right">
              <img
                class="layout__width-100px layout__position-right"
                src="https://rpsassets.blob.core.windows.net/rpsimages/images/instant_print/check.png"
              >
              <h4 class="layout__padding-clear text__align-center layout__padding-20-0 text__colour-teal">
                Check details and confirm
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="activeUploadDialogue"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="500px"
    >
      <div
        class="component__login-dialogue layout__padding-clear"
        v-show="activeUploadDialogue"
      >
        <InstantPrintAppUpload
          v-bind:fileLocation="fileLocation"
          v-bind:filename="filename"
        ></InstantPrintAppUpload>
        <el-button
          class="layout__display-none"
          id="pdfuploadDialog"
          @click="activeUploadDialogue = false"
        ></el-button>
      </div>
    </el-dialog>


    <el-dialog
      :visible.sync="notAccountUsers"
      width="500px"
    >
      <div class="layout__position-center text__align-center">
        <h2 class="text__colour-teal">Get Started</h2>
        <h3 class="text__colour-teal layout__padding-20-0">To use our Instant Print
          <br>
          application, you must have a
          <br>
          credit account for
          <br>
          MyRavensworth
          <br>
          <br>
          You will then be invoiced
          <br>
          monthly for your usage
        </h3>

        <div class="">
          <el-button
            class="button-red button__base layout__position-center layout__width-150px"
            @click="createCreditAccount()"
          >Create credit account
          </el-button>
        </div>

        <p
          class="layout__cursor-pointer layout__padding-20-0"
          @click="openLoginModal()"
        >Already have a credit
          account?
          <br>
          <span class="text__colour-teal">Click here to login</span>
        </p>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="createAccountDialog"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :show-close="true"
      :before-close="resetAccountForm"
      custom-class="credit-application-dialog"
    >
      <div
        class="component__login-dialogue layout__padding-clear"
        v-show="createAccountDialog"
      >
        <CreditApplication
          @closeAccount="createAccountDialog = false"
          account_type="ACCOUNT"
          payment_method="MONTHLYEMAILINVOICE"
          ref="createAccount"
        ></CreditApplication>
        <el-button
          id="createAccountDialog"
          class="layout__display-none"
          @click="createAccountDialog = false"
        ></el-button>
      </div>
    </el-dialog>

    <!--<iframe v-show="pdfupload" style="width: 820px; height: 860px" class="component__pdfupload" v-bind:src="this.launchPdfUpload"></iframe>-->
    <div class="component__footer__terms-and-conditions layout__margin__top-50 layout__position-right layout__padding__right-10px">
      Instant Print version: 1.0002
    </div>
  </div>
</template>

<script>

import { axios } from '@/mixins/Axios.js';
import { dataFormatter } from '@/mixins/DataFormatter.js';
import { backing } from '@/mixins/Backing.js';
import InstantPrintAppUpload from './InstantPrintAppUpload.vue';
import CreditApplication from '../../CreditApplication.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'pdfupload',
  props: {},
  components: {
    InstantPrintAppUpload,
    CreditApplication,
  },
  mixins: [axios, dataFormatter, backing],
  computed: {
    ...mapGetters(
      ['getCookies']),
  },
  data() {
    return {
      activeComponent: 'service',
      rules: {},
      activeUploadDialogue: false,
      fileLocation: '',
      filename: '',
      notAccountUsers: false,
      createAccountDialog: false,
      customer: {},
    };
  },
  created() {
    if (this.returnCookie('_token') === null) {
      window.sessionStorage.setItem('_routerFrom', this.$route.path);
    }

    if (this.$route.params.isCustomStep) {
      this.activeUploadDialogue = false;
    }
  },
  methods: {
    validateAcountUser() {
      if (window.sessionStorage.getItem('_customer') === 'undefined' || window.sessionStorage.getItem('_customer') === null) {
        if (JSON.parse(this.returnCookie('_role')) !== null && JSON.parse(this.returnCookie('_role')).includes('AccountCustomer')) {
          this.notAccountUsers = false;
          this.activeUploadDialogue = true;
        } else {
          // this.notAccountUsers = true;

          document.getElementById('openLoginClosable').click();
        }
      } else {
        this.customer = JSON.parse(window.sessionStorage.getItem('_customer'));

        if (this.customer.accountType !== undefined && this.customer.accountType === 'ACCOUNT') {
          this.notAccountUsers = false;
          this.activeUploadDialogue = true;
        } else {
          // this.notAccountUsers = true;

          document.getElementById('openLoginClosable').click();
        }
      }

      // console.log(document.cookie.match(new RegExp('(^| )' + '_customerType' + '=([^;]+)')))
      // const customerType = document.cookie.match(new RegExp('(^| )' + '_customerType' + '=([^;]+)'))

      // console.log(this.returnAllCookies())
      // // console.log(this.returnCookie('_customerType'))
      //
      // console.log(this.returnCookie('_token'))
      // if (document.cookie.match(new RegExp('(^| )' + '_token' + '=([^;]+)')) === null) {
      //     this.notAccountUsers = true
      // //    todo if this is
      // } else if (customerType !== null && customerType[2] === 'RpsUser') {
      //     this.notAccountUsers = true
      // } else {
      //     this.activeUploadDialogue = true
      // }

      // console.log(this.returnCookie('_customerType'))
      // console.log(this.returnCookie('_customerType') !== null && (this.returnCookie('_customerType') === 'Customer' || this.returnCookie('_customerType') === 'AccountCustomer'))
      //
      // console.log(this.returnCookie('_customerType') !== null )
      //
      //
      //
      // if (this.returnCookie('_token') === null) {
      //     this.notAccountUsers = true
      // } else if (this.returnCookie('_customerType') === null && (this.returnCookie('_customerType') === 'Customer' || this.returnCookie('_customerType') === 'AccountCustomer')) {
      //     this.notAccountUsers = false
      // } else {
      //     this.activeUploadDialogue = true
      // }


      //   this. activeUploadDialogue = false


      // this.notAccountUsers = true


    },
    openLoginModal() {
      this.notAccountUsers = false;
      document.getElementById('openLoginClosable').click();
    },
    createCreditAccount() {
      this.createAccountDialog = true;
      this.notAccountUsers = false;
    },
    resetAccountForm(done) {
      this.$refs.createAccount.resetForm();
      done();
    },

    onGetStarted() {
      if (window.sessionStorage.getItem('_customer') === 'undefined' || window.sessionStorage.getItem('_customer') === null) {
        document.getElementById('openLoginClosable').click();
      } else {
        this.activeUploadDialogue = true;
      }
    },
  },
};
</script>
